import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-2 lg:grid-cols-3 w-full my-3 justify-items-stretch w-1/2 place-content-center gap-3"
}

import Attribution from "./Attribution.vue";
import SquareImage from "./SquareImage.vue";
import { ImageInfo } from "@/ImageInfo";



//show images in a grid and let user select it

interface ImageSelectGridProps {
  images?: ImageInfo[];
}

export default /*#__PURE__*/_defineComponent({
  props: {
    images: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (__props.images)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            key: image.url
          }, [
            _createVNode(SquareImage, {
              image: image,
              size: 40,
              onClick: ($event: any) => (emit('selected', image))
            }, null, 8, ["image", "onClick"]),
            _createVNode(Attribution, {
              image: image,
              class: "mb-4"
            }, null, 8, ["image"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})